import { inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { AuthenticationStore } from "../../states/auth/auth.store";
import { UserProfileStore } from "../../states/user-profile/user-profile.store";
import { from, map, Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class AuthenticationGuardService {

    private readonly authStore = inject(AuthenticationStore);
    private readonly userProfileStore = inject(UserProfileStore);
    private readonly router    = inject(Router);

    private checkAuth(): true | Observable<boolean | UrlTree> {
        this.userProfileStore.rehydrateFromStorage();

        if (this.authStore.isAuthenticated()) {
            return true;
        }

        if (this.authStore.rehydrateAuthFromStorage()) {
            return true;
        }

        // Store is empty (page was refreshed) — try to restore session via refresh token cookie
        return from(this.authStore.refreshSession()).pipe(
            map(() => {
                if (this.authStore.isAuthenticated()) {
                    return true;
                }
                return this.router.createUrlTree(['/login']);
            })
        );
    }

    canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): true | Observable<boolean | UrlTree> {
        return this.checkAuth();
    }

    canActivateChild(_childRoute: ActivatedRouteSnapshot, _state: RouterStateSnapshot): true | Observable<boolean | UrlTree> {
        return this.checkAuth();
    }
}